<app-dialog
  (accept)="onYesClick()"
  (dismiss)="onNoClick()"
  [acceptButtonPrimary]="false">
  <div class="dialog-content">
    <mat-icon class="icon" color="primary">email</mat-icon>
    <p>
      Möchten Sie in Zukunft E-Mails zu wichtigen Neuigkeiten bekommen?
      (z.B. größere Updates oder anstehende Informationsveranstaltungen)
    </p>
    <p>Sie können diese Entscheidung jederzeit unter "Kontoeinstellungen" ändern.</p>
  </div>
</app-dialog>
